<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      title="Danh sách ca tham vấn"
      class="px-5 py-3"
    >
      <v-toolbar color="green">
        <!-- Tìm tham vấn viên để filter ca tham vấn -->
        <select-user
          label="Tìm theo tham vấn viên..."
          role="psychology"
          v-model="select"
        />
        <v-spacer />
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="600"
          v-model="createSlotDialog"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on"
              >Tạo ca tham vấn</v-btn
            >
          </template>
          <template>
            <v-card>
              <v-toolbar color="green" dark>Tạo ca tham vấn</v-toolbar>
              <!-- Tìm người dùng để tạo ca tham vấn -->
              <select-user
                label="Tìm người dùng..."
                v-model="selectSlotUser"
                role="user"
              />
              <div style="height: 12px" />
              <!-- Tìm tham vấn viên để tạo ca tham vấn -->
              <select-user
                label="Tìm tham vấn viên..."
                role="psychology"
                v-model="selectSlotPsychology"
              />
              <div style="height: 12px" />
              <v-dialog
                ref="slotDateDialog"
                v-model="dialogSlotDate"
                :return-value.sync="selectSlotDate"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectSlotDate"
                    label="Chọn ngày"
                    prepend-icon="mdi-calendar"
                    readonly
                    solo
                    v-bind="attrs"
                    v-on="on"
                    class="ma-4"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="selectSlotDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="showSlotDateDialog = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.slotDateDialog.save(selectSlotDate)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
              <v-dialog
                ref="slotTimeDialog"
                v-model="dialogSlotTime"
                :return-value.sync="selectSlotTime"
                persistent
                width="290px"
                class="mt-4"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectSlotTime"
                    label="Chọn giờ"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    solo
                    class="ma-4"
                  ></v-text-field>
                </template>
                <v-time-picker
                  v-if="dialogSlotTime"
                  v-model="selectSlotTime"
                  full-width
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="dialogSlotTime = false">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.slotTimeDialog.save(selectSlotTime)"
                  >
                    OK
                  </v-btn>
                </v-time-picker>
              </v-dialog>
              <v-card-actions class="justify-end">
                <v-btn
                  color="orange"
                  @click="adminCreateSlot"
                  :loading="loadingCreateSlot"
                  :disabled="
                    !selectSlotUser ||
                      !selectSlotPsychology ||
                      !selectSlotDate ||
                      !selectSlotTime
                  "
                  >Đặt lịch</v-btn
                >
                <v-btn @click="closeCreateSlotDialog">Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="slots"
        :page.sync="page"
        :loading="loading"
        single-expand
        :expanded.sync="expanded"
        item-key="_id"
        show-expand
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:[`item.user.name`]="{ item }">
          <div>
            <v-avatar size="36" class="elevation-2">
              <img
                alt="Avatar"
                :src="item.user.avatar || require('@/assets/face.jpg')"
              />
            </v-avatar>
            <span class="ml-5">{{ item.user.name }}</span>
          </div>
        </template>
        <template v-slot:[`item.startTime`]="{ item }">
          {{ formatDate(item.startTime) }}
        </template>
        <template v-slot:[`item.price`]="{ item }">
          {{ formatMoney(item.price) }}
        </template>
        <template v-slot:[`item.booker.name`]="{ item }">
          <div v-if="item.booker">
            <v-avatar size="36" class="elevation-2">
              <img
                alt="Avatar"
                :src="item.booker.avatar || require('@/assets/face.jpg')"
              />
            </v-avatar>
            <span class="ml-5">{{ item.booker.name }}</span>
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div :class="item.booker ? 'green--text' : 'grey--text'">
            {{ item.booker ? "Đã đặt lịch" : "Chưa đặt lịch" }}
          </div>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            x-small
            class="green ml-2"
            @click="rowClick(item)"
            v-if="item.booker"
          >
            Chi tiết
          </v-btn>
          <v-dialog
            v-model="cancelDialog[item._id]"
            width="500"
            v-if="item.booker"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="red ml-2" x-small v-bind="attrs" v-on="on">
                Huỷ lịch
              </v-btn>
            </template>

            <v-card>
              <v-card-title class="text-h3 red white--text font-weight-medium">
                Chú ý
              </v-card-title>

              <v-card-text>
                Bạn có chắc muốn huỷ đặt lịch cho ca này?
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray" @click="cancelDialog[item._id] = false">
                  Huỷ
                </v-btn>
                <v-btn color="red" @click="cancelSlot(item._id)">
                  Đồng ý
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            transition="dialog-bottom-transition"
            max-width="600"
            v-if="!item.booker && itemInFuture(item)"
            v-model="dialog[item._id]"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn x-small class="orange ml-2" v-bind="attrs" v-on="on"
                >Đặt lịch</v-btn
              >
            </template>
            <template>
              <v-card>
                <v-toolbar color="green" dark
                  >Đặt lịch thay người dùng</v-toolbar
                ><select-user
                  label="Chọn người dùng để đặt lịch..."
                  role="user"
                  v-model="selectUser"
                />
                <v-card-actions class="justify-end">
                  <v-btn
                    color="orange"
                    @click="adminBookSlot(item.user._id, item._id)"
                    >Đặt lịch</v-btn
                  >
                  <v-btn @click="closeDialog(item)">Close</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </template>
        <template v-slot:expanded-item="{ item }">
          <td :colspan="headers.length">
            <v-simple-table v-if="item.history && item.history.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Người dùng
                    </th>
                    <th class="text-left">
                      Nội dung
                    </th>
                    <th class="text-left">
                      Thời gian
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="history in item.history || []" :key="history._id">
                    <td>{{ history.user.name }}</td>
                    <td
                      :class="status === booked ? 'green--text' : 'red--text'"
                    >
                      {{ historyStatus(history.status) }}
                    </td>
                    <td>{{ formatDate(history.createdAt) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div v-else>
              Chưa có lịch sử tham vấn
            </div>
          </td>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import SelectUser from "../components/core/SelectUser.vue";
import BookingSlotApi from "@/api/BookingSlotApi";
import UserApi from "@/api/UserApi";
export default {
  components: {
    SelectUser
  },
  data() {
    return {
      headers: [
        {
          text: "Tham vấn viên/Người lắng nghe",
          align: "start",
          sortable: false,
          value: "user.name"
        },
        { text: "Thời gian bắt đầu", value: "startTime" },
        { text: "Giá tiền", value: "price" },
        { text: "Người đặt lịch", value: "booker.name" },
        { text: "Trạng thái", value: "status" },
        { text: "Action", value: "action" },
        { text: "", value: "data-table-expand" }
      ],
      expanded: [],
      page: 1,
      totalPages: 0,
      slots: [],
      loading: true,
      showDetail: false,
      selectedSlot: null,
      select: null,
      selectUser: null,
      loadingBookSlot: false,
      dialog: {},
      cancelDialog: {},
      createSlotDialog: false,
      loadingCreateSlot: false,
      selectSlotUser: null,
      selectSlotPsychology: null,
      bookingPrice: null,
      selectSlotDate: null,
      selectSlotTime: null,
      dialogSlotDate: false,
      dialogSlotTime: false
    };
  },
  watch: {
    select(val) {
      this.page = 0;
      this.loading = true;
      BookingSlotApi.getAll(val)
        .then(response => {
          const { ok, data, headers } = response;
          if (ok) {
            this.slots = data;
            this.totalPages = parseInt(headers["x-total"], 10);
          }
        })
        .catch(err => {
          alert(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await BookingSlotApi.getAll(this.select);
      this.loading = false;
      const { ok, data, headers } = response;
      if (ok) {
        this.slots = data;
        this.page = 1;
        this.totalPages = parseInt(headers["x-total"], 10);
      }
    },

    getItemText(item) {
      return `${item.name} ${item.email}`;
    },

    async adminBookSlot(psychologyId, slotId) {
      this.loadingBookSlot = true;
      const response = await UserApi.adminBookSlot(
        psychologyId,
        slotId,
        this.selectUser
      );
      this.loadingBookSlot = false;
      const { ok, data } = response;
      if (ok) {
        alert("Đặt lịch thành công");
        this.dialog[slotId] = false;
      } else {
        alert(`Đặt lịch không thành công, response: ${data}`);
      }
    },

    async adminCreateSlot() {
      this.loadingCreateSlot = true;
      const response = await BookingSlotApi.adminCreate(
        this.selectSlotPsychology,
        this.selectSlotUser,
        new Date(`${this.selectSlotDate} ${this.selectSlotTime}`)
      );
      this.loadingCreateSlot = false;
      const { ok, data } = response;
      if (ok) {
        alert("Đặt lịch thành công");
        this.createSlotDialog = false;
        this.selectSlotUser = null;
        this.selectSlotPsychology = null;
        this.selectSlotDate = null;
        this.selectSlotTime = null;
        await this.loadData();
      } else {
        alert(`Đặt lịch không thành công, response: ${JSON.stringify(data)}`);
      }
    },

    itemInFuture(item) {
      return new Date(item.startTime) > new Date();
    },

    closeDialog(item) {
      this.dialog[item._id] = false;
    },

    closeCreateSlotDialog() {
      this.createSlotDialog = false;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("vi");
    },

    formatMoney(money) {
      return money ? `${money.toLocaleString("vi")} đ` : "?";
    },

    historyStatus(status) {
      return {
        booked: "Đặt lịch",
        canceled: "Huỷ lịch"
      }[status];
    },

    async goToPage(page) {
      this.page = page;
      this.loading = true;
      const response = await BookingSlotApi.getAll(this.select, page);
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.slots = data;
      }
    },

    rowClick(slot) {
      this.$router.push(`/admin/booking-slots/${slot._id}`);
    },

    async cancelSlot(slotId) {
      const response = await BookingSlotApi.adminCancel(slotId);
      const { ok, data } = response;
      if (!ok) {
        let message = "Huỷ ca không thành công. Có lỗi xảy ra!";
        if (data && data.message) {
          message = `Huỷ ca không thành công. Có lỗi xảy ra: ${data.message}`;
        }
        alert(message);
      }
      this.cancelDialog[slotId] = false;
      this.loadData();
    }
  }
};
</script>
